//import 'ol/ol.css';
import * as toastr from "toastr";
import { INode, FeatureType, IFeatureTypeOptions, ICAMSKey, IFeaturesRequest, IAPIResult, IMapInteractionConfig, CloseFormEnum, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import * as AuthModel from '../Models/AuthModel';
import * as events from '../Bus/Bus';
import { ActivityListType, ActivityListRequestModel, ActivityListFilter, ActivityCreateModel } from '../Activity/Activity';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { MapLayerGroupType, INewGeometryConfig } from '../Models/MapConfigModels';
import { OptionalTracingLayer } from '../Map/MainMap';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_LandContact } from './Entity_LandContact';
import GeometryType from "ol/geom/GeometryType";
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Land {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();
    private Entity_LandContact: Entity_LandContact = new Entity_LandContact();

    private eventNewMapGeometryCompleted;
    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey): void => {
        const self = this;

        // Check to see if the user has permissions, if not pop a toast
        if (self.authModel.policies.find(p => p == AuthModel.CAMSMap_CanEditLand) == null) {
            toastr.error("You do not have rights to edit this type of record.");
            return;
        }

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Land/LandEdit', { landCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create table
            ($('#landEditFurnitureTable') as any).bootstrapTable();
            ($('#landEditRouteTable') as any).bootstrapTable();
            ($('#landEditIssueTable') as any).bootstrapTable();
            ($('#landEditContactTable') as any).bootstrapTable();
            ($('#landEditLandAdminAreaTable') as any).bootstrapTable();
            ($('#landEditLandSection31_6Table') as any).bootstrapTable();
            ($('#landEditTasksTable') as any).bootstrapTable();

            $('#landEditManualRouteBtn').on('click', function () { self.manualLinkRouteOnLand(data); });
            $('#landEditSpatialRouteBtn').on('click', function () { self.spatialLinkRouteOnLand(data); });
            //$('#newFurnitureBtn').on('click', function () { self.createNewInfraOnLand(data); });
            //$('#newIssueBtn').on('click', function () { self.createNewIssuesOnLand(data); });
            $('#landEditNewContactBtn').on('click', function () {
                if (originalFormData !== $('#landEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openContact();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openContact();
                        });
                    });
                }
                else openContact();

                function openContact() {
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);

                    self.Entity_LandContact.openLandContactLinkPanel(data.code, null, null, true, function () { self.openEditPanel(data); });
                }
            });
            // ******************************************************************************
            // Land Edit contacts Table Click Events
            var table: any = Utilities.GetControl('#landEditContactTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                if (field == "name") {
                    //$('#landEditModal [data-landcontactlink]').on('click', function () {
                    var d = $element.find("[data-landcontactlink]").data('landcontactlink');
                    if (originalFormData !== $('#landEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openContact(d);
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openContact(d);
                            });
                        });
                    }
                    else openContact(d);
                }           

                function openContact(d) {
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                    self.Entity_LandContact.openLandContactLinkPanel(d.landCode, d.contactRef, d.contactType, false, function () { self.openEditPanel(data); });
                }
            });

            Utilities.GetModal('#landEditModal', ModalAction.Create);
            // ******************************************************************************
            // Land Edit Route Table Click Events
            // Hyperlinks
            var table: any = Utilities.GetControl('#landEditRouteTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "code") {                    
                    // $('#landEditModal [data-routeref]').on('click', function () {
                    var rdata: ICAMSKey = $element.find("[data-routeref]").data("routeref");
                    if (originalFormData !== $('#landEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openForm();
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openForm();
                            });
                        });
                    }
                    else openForm();                 
                }
                function openForm() {
                    events.bus.publish(events.eventOpenRouteEditPanel(rdata));
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                }
            });
            // ******************************************************************************
            // Land Edit Furniture Table Click Events
            var table: any = Utilities.GetControl('#landEditFurnitureTable');
            table.bootstrapTable(); 
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                //$('#landEditModal [data-infraref]').on('click', function () {
                if (field == "code") {
                    var infradata: ICAMSKey = $element.find("[data-infraref]").data("infraref");
                    if (originalFormData !== $('#landEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openForm();
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openForm();
                            });
                        });
                    }
                    else openForm();
                }               

                function openForm() {
                    events.bus.publish(events.eventOpenInfraEditPanel([infradata,null]));
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                }
            });
            // ******************************************************************************
            // Land Edit Issue Table Click Events
            var table: any = Utilities.GetControl('#landEditIssueTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            //$('#landEditModal [data-issueref]').on('click', function () {
                var idata: ICAMSKey = $element.find("[data-issueref]").data("issueref");
                if (originalFormData !== $('#landEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();
                function openForm() {
                    events.bus.publish(events.eventOpenMaintEditPanel(idata));
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                }
            });

            // ACTIVITY
            getActivities(true); // Get activities when the form first loads
            $('#landEditModal [name="showAllActivities"]').on('change', function () {
                var checked = $(this).prop('checked');
                getActivities(!checked);
            });

            function getActivities(excludeAuditActivities: Boolean) {
                events.bus.publish(events.eventGetActivities([data, excludeAuditActivities, function (d) {
                    var table = ($('#landEditActivityTable') as any);
                    table.bootstrapTable();
                    table.bootstrapTable('load', d);

                    // Add entity cklick events
                    //$('#landEditModal [data-activityid]').on('click', function () {
                    table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                        if (field == "uid") {
                            var actID: number = $element.find("[data-activityid]").data("activityid");
                            if (originalFormData !== $('#landEditForm').serialize()) {
                                Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                                    if (r == CloseFormEnum.DisregardAndProceed) openContact();
                                    else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                        if (s == true) openContact();
                                    });
                                });
                            }
                            else openContact();
                        }                       

                        function openContact() {
                            Utilities.GetModal('#landEditModal', ModalAction.Hide);
                            events.bus.publish(events.eventOpenActivityDetailsPanel([actID, function (r) {
                                if (r == true) {
                                    events.bus.publish(events.eventOpenLandEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                                }
                                else {
                                    Utilities.GetModal('#landEditModal', ModalAction.Show);
                                }
                            }]));
                        }
                    });
                }]));
            }

            $('#landEditNewActivityBtn').on('click', function () {
                if (originalFormData !== $('#landEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                    var activityData: ActivityCreateModel = { ID: data.code, activityListType: ActivityListType.LandActivity };
                    events.bus.publish(events.eventOpenActivityCreatePanel([activityData, function (r) {
                        if (r == true) {
                            events.bus.publish(events.eventOpenLandEditPanel(data)); // This re-opens the edit form which refreshes the Land form
                        }
                        else {
                            Utilities.GetModal('#landEditModal', ModalAction.Show);
                        }
                    }]));
                }
            });

            //initialise photo uploader
            self.photos.setupUploader('#landEditModal');

            // Get UDF's and conditional fields
            $('#LandUse').on('change', function () {
                UserDefinedFields.ShowHideUDFs(<string>$('#LandUse').children("option:selected").val(), $("#landEditForm"));
            });
            UserDefinedFields.ShowHideUDFs(<string>$('#LandUse').children("option:selected").val(), $("#landEditForm"));

            // Tasks
            var table: any = Utilities.GetControl('#landEditTasksTable');
            table.bootstrapTable();

            //$('#landEditModal [data-taskid]').on('click', function () {
            table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                if (field == "taskType") {                   
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                    var taskID = $element.data("taskid");
                    var camsKey: ICAMSKey = { code: taskID, featureType: FeatureType.Task };
                    events.bus.publish(events.eventOpenTasksEditPanel([camsKey, function (r) {
                        events.bus.publish(events.eventOpenLandEditPanel(data)); // This re-opens the edit form which refreshes the route form
                        //if (r == true) {
                        //    events.bus.publish(events.eventOpenLandEditPanel(data)); // This re-opens the edit form which refreshes the route form
                        //}
                        //else {
                        //    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                        //}
                    }]));
                }
                
            });
            $('#landEditNewTaskBtn').on('click', function () {
                if (originalFormData !== $('#landEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#landEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenTasksCreatePanel([[data], function (r) {
                        if (r == true) {
                            events.bus.publish(events.eventOpenLandEditPanel(data)); // This re-opens the edit form which refreshes the route form
                        }
                        else {
                            Utilities.GetModal('#landEditModal', ModalAction.Hide);
                        }
                    }]));
                }
            });

            // Get form validation
            Utilities.InitFormValidation($("#landEditModal"));

            $('#landEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                doSubmit().then(s => { if (s == true) Utilities.GetModal('#landEditModal', ModalAction.Hide); });
            });

            function doSubmit() {
                return new Promise<boolean>(function (resolve, reject) {
                    // Validate
                    let form: any = $('#landEditForm');
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($("#landEditModal .modal-content"));
                    let formData = new FormData(<any>$('#landEditForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/Land/UpdateLand',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    UserDefinedFields.SaveUDFFieldsAtServer($('#landEditForm'), '/Land/UpdateLandUserFields');
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.Land));
                                    events.bus.publish(events.eventEntityUpdated(data));
                                }
                                else {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });

                                }

                                resolve(true);
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                                reject(false);
                            }
                            finally {
                                Utilities.GetModal('#landEditModal', ModalAction.Hide);
                                Utilities.UnBlockUI($("#landEditModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                });
            }

            $('#landEditCancelBtn').on('click', function (evt) {
                if (originalFormData !== $('#landEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal('#landEditModal', ModalAction.Hide);
                    });
                }
                else Utilities.GetModal('#landEditModal', ModalAction.Hide);
            });

            $('#landEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(data);
            });

            // Save the original state of the edit form
            var originalFormData = $('#landEditForm').serialize();

        });
    }

    public openCreatePanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Land/LandCreate', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#landCreateModal', ModalAction.Create);
 
            // Get form validation
            Utilities.InitFormValidation($("#landCreateModal"));

            //initialise photo uploader
            self.photos.setupUploader('#landCreateModal');

            $('#landCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(false);
            });

            $('#landCreateSubmitAndEditBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(true);
            });

            function submit(showEditForm: Boolean) {
                // Validate
                let form: any = $('#landCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#landCreateModal .modal-content"));
                let formData = new FormData(<any>$('#landCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Land/CreateLand',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#landCreateModal', ModalAction.Hide);
                                events.bus.publish(events.eventClearEditLayer());
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Land));
                                events.bus.publish(events.eventEntityUpdated(data));

                                self.newLandWizard_Start();
                                if (showEditForm == true) { self.openEditPanel({ code: result.data.landCode, featureType: FeatureType.Land }) }

                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            }
                            else {
                                if (result.message != null) toastr.error(result.message);
                                else toastr.error('Failed to create feature!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#landCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#landCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#landCreateModal', ModalAction.Hide);
                events.bus.publish(events.eventNewMapGeometryClose(null));
            });
        });
    }

    // ----------------------------------------------------------- //
    // New Land WIZARD
    public newLandWizard_Start = (): void => {
        const self = this;
        
        if (self.map.getView().getZoom() < 15) {
            Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "TS_Toastr_ZoomCloserError" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
            return;
        }

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Land, true]));

        // Capture the end process
        self.eventNewMapGeometryCompleted = events.bus.subscribe(events.eventNewMapGeometryCompleted, e => {
            self.eventNewMapGeometryCompleted();
            if (e.payload[0] == true) {
                self.openCreatePanel(e.payload[1]);
            }
        });

        // Start the process
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false };
        let config: INewGeometryConfig = { data: {}, featureType: FeatureType.Land, interactionData: interactionData, skipStep2withGeom: GeometryType.POLYGON, tracingLayer: OptionalTracingLayer.landPolygonLayer };
        events.bus.publish(events.eventNewMapGeometryStart([config, null]));
    }

    // ----------------------------------------------------------- //
    // GET FEATURE
    public getFeatureAndZoomToLocation = (data: ICAMSKey): void => {
        $.post('/Land/GetLand', { code: data.code },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        if (result.data.WKT != null) {
                            events.bus.publish(events.eventZoomToWKTandHighlight([[result.data.WKT], true, true, FeatureType.Land]));
                        }
                        else {
                            toastr.error('Failed to get land geometry!');
                        }
                    }
                    else {
                        toastr.error('Failed to get land!');
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Land/DeleteLand', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Land));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventResetAllPanels());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            Utilities.GetModal('#landEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // CREATE new linked records
    private createNewInfraOnLand = (data: ICAMSKey): void => {
        toastr.info("To be completed");
        //$('#lanEditModal').modal({ backdrop: 'static', keyboard: false });
        //events.bus.publish(events.eventNewMaintWizardStart(data));
    }

    private createNewIssuesOnLand = (data: ICAMSKey): void => {
        Utilities.GetModal('#landEditModal', ModalAction.Create);
        events.bus.publish(events.eventNewMaintWizardStart([data, null, null]));
    }

    private manualLinkRouteOnLand = (data: ICAMSKey): void => {
        toastr.info("To be completed");
        //$('#landEditModal').modal({ backdrop: 'static', keyboard: false });
        //events.bus.publish(events.eventNewMaintWizardStart(data));
    }

    private spatialLinkRouteOnLand = (data: ICAMSKey): void => {
        toastr.info("To be completed");
        //$('#landEditModal').modal({ backdrop: 'static', keyboard: false });
        //events.bus.publish(events.eventNewMaintWizardStart(data));
    }
}




